import { render, staticRenderFns } from "./ShareWorksReportH.vue?vue&type=template&id=c54dc816&scoped=true&"
import script from "./ShareWorksReportH.vue?vue&type=script&lang=js&"
export * from "./ShareWorksReportH.vue?vue&type=script&lang=js&"
import style0 from "./ShareWorksReportH.vue?vue&type=style&index=0&id=c54dc816&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54dc816",
  null
  
)

export default component.exports